import {Tour} from "../Tour";

const tours = [
  {
    //Temporary deactivation
    // name: "ChallengesTour",
    // steps: [
    //   {
    //     title: "Page Challenges",
    //     intro: "Les challenges sont de courts extraits de morceaux. Chacun permet de travailler une notion clé du piano.",
    //   },
    //   {
    //     title: "Page Challenges",
    //     intro: "Ils peuvent concerner la main gauche seule, la main droite seule ou les deux mains ensembles.",
    //     element: ".challenge-tour__hands"
    //   },
    //   {
    //     title: "Page Challenges",
    //     intro: "Le titre du challenge vous indique la notion principale qu'il va vous permettre de pratiquer.",
    //     element: ".challenge-tour__title"
    //   }
    // ]
  } as Tour
] as Tour[];

export default {tours};
